/**
 * File: /home/cordova03/projects/educore_3.5/src/app/report_cards/published_reports/publishedReportModule.js
 * Project: /home/cordova03/projects/educore_3.5
 * Created Date: Monday, December 10th 2018, 5:44:10 pm
 * Author: Naveen Nazimudeen N
 * -----
 * Last Modified: Wed Dec 12 2018
 * Modified By: Naveen Nazimudeen N
 * -----
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
import template from './views/subject_report.html';
import controller from './controllers/controller';
var module = angular.module('educoreStandardReport', [
    //import modules
]).controller('educoreStandardReport', controller);

module.constant('pulishedReportCardConstants', {
    NO_FEESCHOOLS: ['2FwuqhgeoKt6SQiCG'],
})
// module.config(function ($stateProvider) {
//     "ngInject";

//     $stateProvider
//         .state('educoreStandardReport', {
//             parent: 'app',
//             url: '/educore-standard-report',
//             views: {
//                 '@': {
//                     template: template,
//                     controller: controller,
//                     controllerAs: 'standardreportCtrl'
//                 }
//             }
//         })

// });



// WEBPACK FOOTER //
// ./src/app/educore_reports/standard/module.js